import { render } from "./DungeonMap.vue?vue&type=template&id=2041fec2&scoped=true&lang=html"
import script from "./DungeonMap.vue?vue&type=script&lang=js"
export * from "./DungeonMap.vue?vue&type=script&lang=js"

import "./DungeonMap.vue?vue&type=style&index=0&id=2041fec2&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2041fec2"]])

export default __exports__